<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { StaticViewBuilderViewModel } from "@Alternatives/AlternativesViews/Components/StaticViewBuilder";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class StaticViewBuilder extends Vue
    {
        get vm(): StaticViewBuilderViewModel { return this.$props.viewModel as StaticViewBuilderViewModel; }

        onFormSubmit()
        {
            this.vm.clearValidationErrors();
            this.vm.isSaving = true;
            this.$emit('create-static-list', this.vm.name);
        }

        close()
        {
            this.vm.close();
        }

    }
</script>

<template>
    <div class="modal-mask" v-if="!vm.closed">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create List ({{vm.alternativesIds.length}})</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <form id="static-view-builder-form" @submit.prevent="onFormSubmit">
                            <div class="form-group">
                                <label>List name</label>
                                <input type="text" class="form-control" v-model.trim="vm.name" required minlength="2" maxlength="100">
                                <small class="text-danger">{{vm.nameError}}</small>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="static-view-builder-form" :disabled="vm.isSaving" class="btn btn-primary">Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>